import { jsx as _jsx } from "react/jsx-runtime";
import { GuidaPromptProvider } from '../context/promptContext';
/** Component to hold all common providers used in the Guida framework and consuming apps. */
export const GuidaFrameworkProviders = ({ children, dexfAppSettings }) => {
    return (_jsx(GuidaPromptProvider, { homePageLink: dexfAppSettings.kompis.urls.homePageLink, children: children }));
};
//# sourceMappingURL=GuidaFrameworkProviders.js.map